import type { PropsWithChildren, FC } from 'react'
import type { ListboxItemProps } from '@ark-ui/react/listbox'
import { Listbox } from '@ark-ui/react/listbox'
import { cn } from '@/utils'

export const TiptapSuggestionListItem: FC<
  PropsWithChildren<ListboxItemProps>
> = ({ children, className, ...props }) => {
  return (
    <Listbox.Item
      {...props}
      className={cn(
        'cursor-pointer',
        'transition-colors ease-in-out duration-300',
        'last:px-1 last:py-0.5',
        className,
      )}
    >
      {children}
    </Listbox.Item>
  )
}
